/* eslint-disable import/no-cycle */
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentEditListIndices, setOuterListActionButton } from '../../redux/actions/questions';
import ListQuestions from './ListQuestions';

const NestedListQuestions = ({
  item,
  isReview,
  changeMode,
  sectionIndex,
  isNestedQ,
  listParentId,
  parentListIndex,
  showListActions,
  handleSetCurrentEditListIndices,
  editingParentListIndex,
  handleSetOuterListActionButton,
  enableOuterActionButton,
  theme,
  reflexLevel,
}) => {
  const nestedListProps = {
    isNestedQ,
    listParentId,
    parentListIndex,
    showListActions,
  };
  const listDisplay = get(item, 'child_questions_completed_flag', false);

  useEffect(() => {
    if (!listDisplay && enableOuterActionButton) {
      handleSetOuterListActionButton(false, sectionIndex);
    }
    if (
      !listDisplay &&
      Number.isInteger(parentListIndex) &&
      editingParentListIndex !== parentListIndex
    ) {
      handleSetCurrentEditListIndices(parentListIndex, null, sectionIndex, listParentId);
    }
  }, [listDisplay]);
  return (
    <ListQuestions
      item={ item }
      sectionIndex={ sectionIndex }
      changeMode={ changeMode }
      isReview={ isReview }
      nestedListProps={ nestedListProps }
      theme={ theme }
      reflexLevel={ reflexLevel }
    />
  );
};

const mapStateToProps = (state) => {
  const { editingParentListIndex, enableOuterActionButton } = get(state, 'questions', null);
  return {
    editingParentListIndex,
    enableOuterActionButton,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleSetCurrentEditListIndices: (
      parentListIndex,
      childListIndex,
      sectionIndex,
      listParentId,
    ) =>
      dispatch(
        setCurrentEditListIndices(parentListIndex, childListIndex, sectionIndex, listParentId),
      ),
    handleSetOuterListActionButton: (shouldEnable, sectionIndex) =>
      dispatch(setOuterListActionButton(shouldEnable, sectionIndex)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NestedListQuestions);
